import { CalcsProps } from "../../data";

export function scrollLeft(anims, calcs: CalcsProps, stateAnims, dirAnim) {
    let t = anims[dirAnim] + calcs.step * calcs.multiplier;
    anims[dirAnim] = t > 0 ? 0 : t;
    let animationDirection = {};
    animationDirection[dirAnim] = anims[dirAnim].toString() + "px";
    let o = { ...stateAnims, animation: animationDirection }
    return { anims: { ...o } };
}